// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  .logos {
    display: flex;
    justify-content: center;
    img {
      height: 57px;
      @media (max-width: 767px) {
        height: 45px;
      }
    }
  }
  .logo-seperator {
    width: 100px;
    height: 1px;
    transform: translate(0, 28px) rotate(90deg);
    background-color: ${(props) => props.theme.colors.PRIMARY.GRAY};
    display: inline-block;
    margin: 0 -15px;
  }
  .logo {
    width: 192px;
  }
  .my-rewards-img-wrapper {
    width: 192px;
  }
  .heading-style {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 24px;
    }
  }
  .sub-heading-style {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 16px;
    }
  }
  .sub-heading-style-2 {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 14px;
    }
  }
`;

export default styles;
